import React from 'react';
import PropTypes from 'prop-types';
import * as Styled from '../../Footer.styles';

var GridItem = function GridItem(_ref) {
  var children = _ref.children,
      _ref$title = _ref.title,
      title = _ref$title === void 0 ? '' : _ref$title;
  return /*#__PURE__*/React.createElement(Styled.SecondaryFooterItem, null, /*#__PURE__*/React.createElement(Styled.Title, null, title), /*#__PURE__*/React.createElement("div", {
    className: "md-12"
  }, children));
};

GridItem.propTypes = {
  children: PropTypes.node,
  title: PropTypes.string
};
export default GridItem;